const DB_NAME = "resultsDB";
const DB_VERSION = 1;
const STORE_NAME = "results";
const MAX_ROWS = 10;

// Open the database
async function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = event => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };

    request.onsuccess = event => resolve(event.target.result);
    request.onerror = event => reject(event.target.error);
  });
}

// Add a result, trimming oldest if > MAX_ROWS
async function addResult(object) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  object._addedAt = Date.now();
  store.put(object);

  // Get all results from the same transaction
  const allResults = await store.getAll();

  if (allResults.length > MAX_ROWS) {
    const sorted = allResults.sort((a, b) => a._addedAt - b._addedAt);
    const excess = sorted.slice(0, allResults.length - MAX_ROWS);
    excess.forEach(item => store.delete(item.id));
  }

  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = e => reject(e);
  });
}

// Delete a specific result by ID
async function deleteResultById(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    const request = store.delete(id);

    request.onsuccess = () => resolve();
    request.onerror = (e) => reject(e);
  });
}


// Get all results
async function getAllResults() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const request = store.getAll();

    request.onsuccess = () => resolve(request.result);
    request.onerror = e => reject(e);
  });
}

// Get a specific result by ID
async function getResultById(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(id);

    request.onsuccess = () => resolve(request.result);
    request.onerror = e => reject(e);
  });
}
 


export {addResult, getResultById, getAllResults, deleteResultById}